// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3l-aH","newExpiryDate":"styles_newExpiryDate__y1Dk8","footer":"styles_footer__lDR9g"};